'use client';
import type { EChartsOption } from 'echarts';
import React from 'react';

const ReactECharts = React.lazy(() => import('echarts-for-react'));

export const StackedBarChart = ({ data }) => {
  const months = data?.data?.map(item => {
    return item.month.slice(0, 3) + ' ' + item.year;
  });

  const buys = data?.data?.map(item => {
    return item.bought.amount;
  });

  const sells = data?.data?.map(item => {
    return item.sold.amount;
  });

  const options = React.useMemo(() => {
    return {
      grid: {
        bottom: '3%',
        containLabel: true,
        left: '0%',
        right: '8%',
      },
      legend: {
        show: false,
      },
      series: [
        {
          color: '#56d288',
          data: buys,
          emphasis: {
            focus: 'series',
          },
          itemStyle: {
            borderRadius: [3, 3, 0, 0],
          },
          name: 'Buy Volume',
          type: 'bar',
        },
        {
          color: '#f85656',
          data: sells,
          emphasis: {
            focus: 'series',
          },
          itemStyle: {
            borderRadius: [3, 3, 0, 0],
          },
          name: 'Sell Volume',
          type: 'bar',
        },
      ],
      tooltip: {
        axisPointer: {
          type: 'shadow',
        },
        trigger: 'axis',
      },
      xAxis: [
        {
          axisLabel: {
            formatter: val => val.slice(0, 3),
          },
          axisTick: { show: false },
          data: months,
          type: 'category',
        },
      ],
      yAxis: [
        {
          axisLabel: { show: false },
          axisLine: { show: false },
          axisTick: { show: false },
          max: 'dataMax',
          min: 0,
          splitLine: { show: false },
        },
      ],
    };
  }, [buys, months, sells]);

  return <ReactECharts notMerge={true} option={options as EChartsOption} style={{ height: '220px', width: '100%' }} />;
};
